import { useListSuggestions } from "@shared/generated/crm";

export const usePendingProfileReviewCount = () => {
  const { data } = useListSuggestions({ status: "pending", pageSize: 1 });
  return data?.total;
};
